var _excluded = ["horizontalAlign", "horizontalAlignType", "verticalAlign", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import React, { forwardRef } from "react";
import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import { defaultProps } from "./AlignContentOrg.props";
var horizontalAlignValuesType = {
  "default": {
    flex: "initial",
    text: "left"
  },
  left: {
    flex: "flex-start",
    text: "left"
  },
  center: {
    flex: "center",
    text: "center"
  },
  right: {
    flex: "flex-end",
    text: "right"
  }
};
var verticalAlignValuesType = {
  top: "flex-start",
  center: "center",
  bottom: "flex-end"
};
var basicVerticalAlignStyles = function basicVerticalAlignStyles($verticalAlign) {
  var verticalAlignValueType;
  if ($verticalAlign) {
    verticalAlignValueType = verticalAlignValuesType[$verticalAlign];
  }
  return css(["", ""], verticalAlignValueType && css(["justify-content:", ";"], verticalAlignValueType));
};
var verticalAlignStyles = function verticalAlignStyles($verticalAlign) {
  if (_typeof($verticalAlign) === "object") {
    return css(["", ";", "{", ";}", "{", ";}"], basicVerticalAlignStyles($verticalAlign.small), breakpoint("medium"), basicVerticalAlignStyles($verticalAlign.medium), breakpoint("large"), basicVerticalAlignStyles($verticalAlign.large));
  }
  return basicVerticalAlignStyles($verticalAlign);
};
var basicHorizontalStyles = function basicHorizontalStyles($horizontalAlign, $horizontalAlignType) {
  var horizontalAlignValueType = $horizontalAlign && horizontalAlignValuesType[$horizontalAlign];
  return css(["", ""], horizontalAlignValueType && css(["", " ", " ", ""], $horizontalAlignType === "both" && css(["align-items:", ";text-align:", ";"], horizontalAlignValueType.flex, horizontalAlignValueType.text), $horizontalAlignType === "flex" && css(["align-items:", ";"], horizontalAlignValueType.flex), $horizontalAlignType === "text" && css(["text-align:", ";"], horizontalAlignValueType.text)));
};
var horizontalAlignStyles = function horizontalAlignStyles($horizontalAlign, $horizontalAlignType) {
  if (_typeof($horizontalAlign) === "object") {
    return css(["", ";", "{", ";}", "{", ";}"], basicHorizontalStyles($horizontalAlign.small, $horizontalAlignType), breakpoint("medium"), basicHorizontalStyles($horizontalAlign.medium, $horizontalAlignType), breakpoint("large"), basicHorizontalStyles($horizontalAlign.large, $horizontalAlignType));
  }
  return basicHorizontalStyles($horizontalAlign, $horizontalAlignType);
};
var StyledAlignContentOrg = styled.div.withConfig({
  componentId: "sc-1uayj68-0"
})(function (_ref) {
  var $horizontalAlign = _ref.$horizontalAlign,
    $horizontalAlignType = _ref.$horizontalAlignType,
    $verticalAlign = _ref.$verticalAlign;
  return css(["display:flex;flex-direction:column;", " ", ""], horizontalAlignStyles($horizontalAlign, $horizontalAlignType), verticalAlignStyles($verticalAlign));
});
var AlignContentOrg = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var _ref2$horizontalAlign = _ref2.horizontalAlign,
    horizontalAlign = _ref2$horizontalAlign === void 0 ? defaultProps.horizontalAlign : _ref2$horizontalAlign,
    _ref2$horizontalAlign2 = _ref2.horizontalAlignType,
    horizontalAlignType = _ref2$horizontalAlign2 === void 0 ? defaultProps.horizontalAlignType : _ref2$horizontalAlign2,
    verticalAlign = _ref2.verticalAlign,
    children = _ref2.children,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledAlignContentOrg, _extends({
    ref: ref,
    $horizontalAlign: horizontalAlign,
    $horizontalAlignType: horizontalAlignType,
    $verticalAlign: verticalAlign
  }, restProps), children);
});
export default AlignContentOrg;